import axios from 'axios';
import { useEffect, useState } from 'react';
import { HeaderData } from '../types/ee-header';
import { stripAemPrefixFromObject } from '../utils';

export function useHeaderData(endpoint: string) {
  const [data, setData] = useState<HeaderData | null>(null);
  useEffect(() => {
    let mounted = true;
    const controller = new AbortController();
    (async () => {
      try {
        const resp = await axios.get(endpoint, { signal: controller.signal });
        if (mounted && resp?.data && typeof resp.data === 'object') {
          setData(stripAemPrefixFromObject(resp.data));
        }
      } catch (err) {
        if (!controller.signal.aborted && mounted) {
          console.warn('Header data fetch failed, using fallback:', err);
        }
      }
    })();
    return () => {
      mounted = false;
      controller.abort();
    };
  }, [endpoint]);
  return data;
}
